import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-item-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 3 }

import { onMounted, reactive, ref, watch } from "vue";
import { AddressService } from "@/api/services/AddressService";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Address } from "@/api/models/address/Address";
import { AddressAddRequest } from "@/api/models/address/AddressAddRequest";
import { AddressUpdateRequest } from "@/api/models/address/AddressUpdateRequest";
import { AddressListRequest } from "@/api/models/address/AddressListRequest";
import { UserService } from "@/api/services/UserService";
import { User } from "@/api/models/user/User";
import { PostalService } from "@/api/services/PostalService";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAddress',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<AddressListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const addressList = ref<Address[]>([]);

const handleList = async () => {
  const res = await AddressService.ListAll(listRequest);
  if (res.code === 0) {
    addressList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const userList = ref<User[]>([]);

const handleUserList = async () => {
  const res = await UserService.ListAll({ current: 0, size: 0 });
  if (res.code === 0) {
    userList.value = res.data.records;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
  await handleUserList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const addRequest = reactive<AddressAddRequest>({
  name: "",
  phone: "",
  address: "",
  postcode: "",
  category: 1,
  province: "",
  city: "",
  district: "",
  is_default: 1,
});

const handleGetPostalCodeAdd = async () => {
  const res = await PostalService.Get({
    province: addRequest.province,
    city: addRequest.city,
    district: addRequest.district,
  });
  if (res.code === 0) {
    addRequest.postcode = res.data.postcode;
  } else {
    message.error(res.msg);
  }
};

watch(
  () => [addRequest.province, addRequest.city, addRequest.district],
  ([newProvince, newCity, newDistrict]) => {
    if (newProvince && newCity && newDistrict) {
      handleGetPostalCodeAdd();
    }
  }
);

const openAdd = ref(false);

const submitAdd = async () => {
  const res = await AddressService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<AddressUpdateRequest>({
  id: 0,
  is_delete: 0,
  user_id: 0,
  name: "",
  phone: "",
  address: "",
  postcode: "",
  category: 0,
  province: "",
  city: "",
  district: "",
  is_default: 0,
});

const handleGetPostalCodeUpdate = async () => {
  const res = await PostalService.Get({
    province: updateRequest.province,
    city: updateRequest.city,
    district: updateRequest.district,
  });
  if (res.code === 0) {
    updateRequest.postcode = res.data.postcode;
  } else {
    message.error(res.msg);
  }
};

watch(
  () => [updateRequest.province, updateRequest.city, updateRequest.district],
  ([newProvince, newCity, newDistrict]) => {
    if (newProvince && newCity && newDistrict) {
      handleGetPostalCodeUpdate();
    }
  }
);

const handleUpdate = (record: Address) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await AddressService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Address) => {
  const res = await AddressService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Address) => {
  const res = await AddressService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "用户id",
    dataIndex: "user_id",
    align: "center",
  },
  {
    title: "收/寄件人名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "电话号码",
    dataIndex: "phone",
    align: "center",
  },
  {
    title: "省份",
    dataIndex: "province",
    align: "center",
  },
  {
    title: "城市",
    dataIndex: "city",
    align: "center",
  },
  {
    title: "县区",
    dataIndex: "district",
    align: "center",
  },
  {
    title: "地址信息",
    dataIndex: "address",
    align: "center",
  },
  {
    title: "邮政编码",
    dataIndex: "postcode",
    align: "center",
  },
  {
    title: "是否为默认",
    dataIndex: "is_default",
    align: "center",
  },
  {
    title: "地址类型",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: handleList,
      class: "search-form",
      onSubmit: handleList
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { name: "content" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "label" }, "搜索内容：", -1)),
              _createVNode(_component_a_input, {
                placeholder: "姓名/电话",
                value: listRequest.content,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((listRequest.content) = $event))
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit"
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [
                _createTextVNode("搜索")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openAdd.value = true)),
              style: {"margin-bottom":"16px"}
            }, {
              default: _withCtx(() => _cache[26] || (_cache[26] = [
                _createTextVNode(" 添加用户地址 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": addressList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }: { column: ColumnType, record: Address }) => [
        (column.dataIndex === 'is_delete')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.is_delete === 1)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode("正常")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.is_delete === 2)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "red"
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode("回收站")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : (column.dataIndex === 'is_default')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (record.is_default === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "非默认"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, "默认"))
              ], 64))
            : (column.dataIndex === 'category')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (record.is_default === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "寄件地址"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, "收件地址"))
                ], 64))
              : (column.dataIndex === 'create_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                : (column.dataIndex === 'operator')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (handleUpdate(record)),
                        type: "primary",
                        style: { marginRight: '8px' }
                      }, {
                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                          _createTextVNode("编辑 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDelete(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                      }, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createTextVNode("删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDrop(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                      }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createTextVNode("彻底删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"]),
    _createVNode(_component_a_modal, {
      open: openAdd.value,
      "onUpdate:open": _cache[12] || (_cache[12] = ($event: any) => ((openAdd).value = $event)),
      title: "添加用户地址数据",
      onOk: submitAdd,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: addRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "会员" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addRequest.user_id,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addRequest.user_id) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (user) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: user.id,
                        key: user.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(user.id) + " - " + _toDisplayString(user.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "收/寄件人名称：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.name,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "电话：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.phone,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((addRequest.phone) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "省份：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.province,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((addRequest.province) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "城市：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.city,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((addRequest.city) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "县区：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.district,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((addRequest.district) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "详细地址：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: addRequest.address,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((addRequest.address) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "邮政编码：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.postcode,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((addRequest.postcode) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addRequest.category,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((addRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("寄件地址")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("收件地址")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "是否默认：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: addRequest.is_default,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((addRequest.is_default) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("非默认")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("默认")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: openUpdate.value,
      "onUpdate:open": _cache[23] || (_cache[23] = ($event: any) => ((openUpdate).value = $event)),
      title: "修改快递数据",
      onOk: submitUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: updateRequest,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "收/寄件人名称：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.name,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((updateRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "电话：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.phone,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((updateRequest.phone) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "省份：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.province,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((updateRequest.province) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "城市：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.city,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((updateRequest.city) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "县区：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.district,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((updateRequest.district) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "详细地址：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: updateRequest.address,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((updateRequest.address) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "邮政编码：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.postcode,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((updateRequest.postcode) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.category,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((updateRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("寄件地址")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createTextVNode("收件地址")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "是否默认：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: addRequest.is_default,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((addRequest.is_default) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode("非默认")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createTextVNode("默认")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.is_delete,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((updateRequest.is_delete) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[40] || (_cache[40] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[41] || (_cache[41] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})